import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import { ASSISTANT_INITIAL_VALUE } from "../../../../../features/Assistants/Constants";
import {
  changeResponseFormatAction,
  deleteAssistantAction,
  getAssistantFunctionsAction,
  getAssistantMessagesAction,
  migrationAssistantVersionToNewApiAction,
} from "../../../../../features/Assistants/redux/actions";
import {
  clearMessagesAction,
  setAssistantValue,
  setChatHistory,
  setFunctionsAction,
} from "../../../../../features/Assistants/redux/slice";
import { RootState } from "../../../types";
import { ServiceHandler } from "./storageHandlers";
import { generateId } from "../../../../../shared/utils/generateId";
import { AssistantValue } from "../../../../api/instances/assistantsApi/types";
import { fetchAllStorageObjectVersions } from "../../../../../app/state/storageObjectSlice/actions/versioning-actions";
import { deleteThread } from "../../../../api/instances/responseApi/api";
import { setSelectedObjectId } from "../../../../../app/state/storageObjectSlice/slice";
import { deleteStorageObjectVersion } from "../../../../api/instances/storageApi/versioningMethods";
import { StorageObjectVersion } from "../../../../api/instances/storageApi/types/object_types";
import { StorageObjectValue } from "../../../../api/instances/storageApi/types/service_types";
import { APP_VECTOR_STORE_MODE } from "../../../../api/constants";
import { isNonUuidAssistantId } from "../../../../lib/isNonUuidAssistantId";

export const AssistantService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      const functions =
        listenerApi.getState().assistantsState.assistantFunctions;
      const model = listenerApi.getState().modelsState.models[0];
      listenerApi.dispatch(clearMessagesAction());
      const initialValue: AssistantValue = {
        assistant_object: {
          ...ASSISTANT_INITIAL_VALUE,
          id: `asst_${generateId()}`,
          name: normalized.friendly_name,
          model: model.id,
          thread_id: "",
        },
        meta: {
          isThreadStarted: false,
          isLegacyObject: false,
          server_type: "openai",
        },
      };
      await listenerApi.dispatch(
        editStorageObject({
          id: normalized.id,
          name: normalized.friendly_name,
          value: initialValue,
          service: "assistants",
          skipUpdateListener: true,
        }),
      );
      listenerApi.dispatch(
        setSelectedObjectId({
          id: normalized.id,
          service: "assistants",
          skipSelectHandler: true,
        }),
      );
      // listenerApi.dispatch(
      //   setFunctionsAction(
      //     functions.map((func) => ({
      //       ...func,
      //       selected: false,
      //     })),
      //   ),
      // );
      listenerApi.dispatch(setAssistantValue(initialValue));
    } catch (e) {
      console.error("Ошибка при создании ассистента", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    const assistantValue = value as AssistantValue;
    const { chatHistory } = listenerApi.getState().assistantsState;

    if (!chatHistory[id]) {
      listenerApi.dispatch(setChatHistory({ id: id, history: [] }));
    }
    try {
      listenerApi.dispatch(setAssistantValue(assistantValue));
      await listenerApi.dispatch(changeResponseFormatAction(id));
      // listenerApi.dispatch(
      //   getAssistantFunctionsAction({
      //     id: assistantValue?.assistant_object.id as string,
      //   }),
      // );
      listenerApi.dispatch(
        fetchAllStorageObjectVersions({ service: "assistants" }),
      );
      listenerApi.dispatch(clearMessagesAction());
      const { thread_id } = assistantValue?.assistant_object;

      if (thread_id) {
        listenerApi.dispatch(
          getAssistantMessagesAction({ threadRef: thread_id, id }),
        );
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onSelectVersion(listenerApi, id, value) {
    if (id === null || value === null) return;
    const assistantValue = value as AssistantValue;
    try {
      // listenerApi.dispatch(
      //   getAssistantFunctionsAction({
      //     id: assistantValue?.assistant_object.id as string,
      //     value: assistantValue,
      //   }),
      // );
      const { meta } = assistantValue;
      const isLegacy = meta?.isLegacyObject;
      listenerApi.dispatch(setAssistantValue(assistantValue));

      if (isLegacy === true || isLegacy === undefined) {
        listenerApi.dispatch(
          migrationAssistantVersionToNewApiAction({
            id,
            value: value as AssistantValue,
          }),
        );
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onDelete(listenerApi, id, value) {
    if (id === null || value === null) return;
    const assistantValue = value as AssistantValue;
    try {
      const { versions, selectedId } = (listenerApi.getState() as RootState)
        .storageObjectState.assistants;
      const assistant = assistantValue?.assistant_object;
      const { meta } = assistantValue;
      const { thread_id } = assistant;
      const assistantId = assistant?.id as string;
      if (
        APP_VECTOR_STORE_MODE !== "local" &&
        isNonUuidAssistantId(assistantId)
      ) {
        await listenerApi.dispatch(
          deleteAssistantAction(assistantValue?.assistant_object?.id as string),
        );
      }
      if (thread_id && meta?.isThreadStarted === true) {
        await deleteThread(thread_id);
      }
      if (versions && selectedId) {
        const currentVersions = versions[selectedId];
        await Promise.all(
          currentVersions.map(
            (version: StorageObjectVersion<StorageObjectValue>) =>
              deleteStorageObjectVersion(
                selectedId as string,
                version?.version_id as string,
                "assistants",
              ),
          ),
        );
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
};
